exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headerButt, .headerButt:visited {\n  background-color: #6376A0;\n  color: white;\n  box-shadow: 2px 2px #ECB807; }\n\n.headerButt:hover {\n  background-color: #1D3060;\n  color: #ECB807;\n  box-shadow: 2px 2px white; }\n", ""]);

// exports
